import { render, staticRenderFns } from "./CascoInsurance.vue?vue&type=template&id=44f2f516"
import script from "./CascoInsurance.vue?vue&type=script&lang=ts"
export * from "./CascoInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports